import React from 'react';
import { Button } from './ui/Button';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-slate-50 overflow-hidden pt-20 pb-24 lg:pt-32 lg:pb-40" data-id="element-27">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-28">
        <div className="max-w-4xl mx-auto text-center" data-id="element-29">
          <div className="inline-flex items-center rounded-full bg-blue-50 px-3 py-1 text-sm font-medium text-blue-900 mb-8 ring-1 ring-inset ring-blue-700/10" data-id="element-30">
            <ShieldCheck className="w-4 h-4 mr-2" data-id="element-31" />
            Trusted by over 500 families in Poland
          </div>

          <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-6xl mb-6" data-id="element-32">
            Precision Financial Engineering for{' '}
            <span className="text-blue-900" data-id="element-33">Generational Wealth</span>
          </h1>

          <p className="text-lg leading-8 text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-34">
            Powerquest delivers sophisticated capital strategies for
            high-net-worth individuals. We architect your financial future with
            mathematical precision and unwavering fiduciary duty.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-35">
            <Button size="lg" className="w-full sm:w-auto group" data-id="element-36">
              Start Your Trajectory
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-37" />
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-38">
              View Methodology
            </Button>
          </div>
        </div>
      </div>

      {/* Abstract Background Pattern */}
      <div className="absolute inset-0 -z-10 opacity-30" data-id="element-39">
        <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" data-id="element-40">
          <path d="M0 100 C 20 0 50 0 100 100 Z" fill="#e2e8f0" data-id="element-41" />
        </svg>
      </div>
    </section>;
}